import { createFileRoute } from "@tanstack/react-router";
import { ComingSoonPage } from "@/components/layout/page-container.tsx";

export const Route = createFileRoute("/algorithms")({
  component: () => <ComingSoonPage title="算法广场" />,
});
